import { useEffect, useState, useContext } from 'react';

import { getAwardedVendors } from '../Profile.api';
import { IAwardedVendors } from '../Profile.type';

import { DashboardContext } from '@/providers/DashboardContext';

const useGetVendors = () => {
  const [loading, setLoading] = useState(true);
  const [vendors, setVendors] = useState<IAwardedVendors>();
  const { updateDashboardState } = useContext(DashboardContext);

  const getVendorsInfo = async () => {
    setLoading(true);
    try {
      const vendorsRes = await getAwardedVendors();
      setVendors(vendorsRes?.data?.data);
      updateDashboardState({ dashboardVendorData: vendorsRes?.data?.data });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVendorsInfo();
  }, []);

  return {
    loading,
    vendors,
    getVendorsInfo,
  };
};

export default useGetVendors;
